export const SUPPORT_PHONE_NUMBER = "833-518-1613";

// The provider support line, as on the Contact Us page.
export const PROVIDER_SUPPORT_PHONE_NUMBER = "(929) 383-5362";

export const WOUND_CARE_ORDER_FORM_URL =
  "https://verse-public-assets.s3.us-east-2.amazonaws.com/wound-care-order-form.pdf";

export const ACCOUNT_REP_PHOTOS_URL =
  "https://verse-public-assets.s3.us-east-2.amazonaws.com/account_representatives";
